import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import IMG_1_1 from 'assets/images/scooter/mix/img-mix-swiper-pc-1.png'
import IMG_1_2 from 'assets/images/scooter/mix/img-mix-swiper-mobile-1.png'

import IMG_2_1 from 'assets/images/scooter/mix/img-mix-swiper-pc-2.png'
import IMG_2_2 from 'assets/images/scooter/mix/img-mix-swiper-mobile-2.png'

import IMG_3_1 from 'assets/images/scooter/mix/img-mix-swiper-pc-3.png'
import IMG_3_2 from 'assets/images/scooter/mix/img-mix-swiper-mobile-3.png'

import IMG_4_1 from 'assets/images/scooter/mix/img-mix-swiper-pc-4.png'
import IMG_4_2 from 'assets/images/scooter/mix/img-mix-swiper-mobile-4.png'

import IMG_5_1 from 'assets/images/scooter/mix/img-mix-swiper-pc-5.png'
import IMG_5_2 from 'assets/images/scooter/mix/img-mix-swiper-mobile-5.png'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

/**
 * @file 스마트스쿠터-VIVA MIX 화면에서의 swiper
 */
function ScooterMixImgSwiper() {
    var describesOne = [
        { pcUrl: IMG_1_1, mobileUrl: IMG_1_2, title: '' },
        { pcUrl: IMG_2_1, mobileUrl: IMG_2_2, title: '' },
        { pcUrl: IMG_3_1, mobileUrl: IMG_3_2, title: '' },
        { pcUrl: IMG_4_1, mobileUrl: IMG_4_2, title: '' },
        { pcUrl: IMG_5_1, mobileUrl: IMG_5_2, title: '' },
    ]
    const settings = {
        className: 'swiper-describe-one swiper-box',
        direction: 'horizontal',
        modules: [Navigation],
        navigation: {
            nextEl: '.slide-control-btn.next',
            prevEl: '.slide-control-btn.prev',
        },
        slidesPerView: 'auto',
        spaceBetween: 32,
        loop: false,
        centeredSlides: true,
        breakpoints: {
            100: {
                centeredSlides: false,
                spaceBetween: 15,
            },
            768: {
                centeredSlides: false,
                spaceBetween: 32,
            },
            1180: {
                centeredSlides: false,
                spaceBetween: 34,
            },
        },
    }

    return (
        <Swiper {...settings}>
            <div className="swiper-wrapper">
                {describesOne.map((val, i) => (
                    <SwiperSlide className="swiper-slide" key={'scooter-viva-img-desc-swiper-slide-' + i}>
                        <img className="img-box pc" src={val.pcUrl} alt="" />
                        <img className="img-box mobile" src={val.pcUrl} alt="" />
                        <div className="text-box">
                            <div className="t1">{val.title}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </div>
        </Swiper>
    )
}

export default ScooterMixImgSwiper
